/**
 * Construye la URL pública de una imagen de inventario guardada en storage.
 */
export function buildInventoryImageUrl(imagePath) {
  if (!imagePath) return null;

  const path = String(imagePath).trim();
  if (!path) return null;

  if (/^https?:\/\//i.test(path)) {
    // URLs mal generadas con APP_URL del frontend (puerto 8080)
    if (/localhost:8080|:8080\//i.test(path)) {
      const apiBase = (process.env.VUE_APP_API_BASE_URL || "")
        .trim()
        .replace(/\/api\/?$/, "");
      const storagePath = path.replace(/^https?:\/\/[^/]+/i, "");
      return `${apiBase}${storagePath.startsWith("/") ? storagePath : `/${storagePath}`}`.replace(
        /([^:]\/)\/+/g,
        "$1"
      );
    }
    return path;
  }

  if (path.startsWith("/storage/")) {
    const apiBase = (process.env.VUE_APP_API_BASE_URL || "")
      .trim()
      .replace(/\/api\/?$/, "");
    return `${apiBase}${path}`;
  }

  const imgBase = (process.env.VUE_APP_API_IMAGE_URL || "").trim().replace(/\/$/, "");
  const cleanPath = path.replace(/^\//, "").replace(/^storage\//, "");

  return `${imgBase}/${cleanPath}`;
}

/** Nombre para ticket POS: invoice_name si existe, si no name. */
export function inventoryTicketName(item) {
  const invoice = item?.invoice_name != null ? String(item.invoice_name).trim() : "";
  if (invoice) {
    return invoice;
  }
  return item?.name || "Producto";
}
